module.exports = __webpack_public_path__ + "static/compass-7574ac9db456280f9c963460f07f525a.png";